import { ReturnComponentType } from 'common';
import { FullLoader, NotifyComponent } from 'components';
import { NotifyType } from 'enums';
import { useAppSelector } from 'hooks';
import './Header.scss';
import { selectError } from 'state';

export const Header = (): ReturnComponentType => {
  const error = useAppSelector(selectError);

  return (
    <header className="Header">
      <FullLoader />
      {error && <NotifyComponent message={error} type={NotifyType.ERROR} isError />}
    </header>
  );
};
